import React from 'react';
import { Select } from 'antd';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { CALL_OUTCOME_TAGS, isOutcomeVisible } from '../VoiceOutbound/constants';
import {
  getCompactMultiSelectMaxTagCount,
  getCompactMultiSelectPlaceholder,
} from '../../../utils/compactMultiSelect';
import { captureAnalytics } from '../../../actions/preload';

const CallOutcomeFilter = ({
  updateQuery,
  selectedCallOutcomes,
  setSelectedCallOutcomes,
  inboundDeliveryOutcomesEnabled,
  inboundDeliveryOutcomes,
}) => {
  const handleCallOutcomeChange = (value) => {
    setSelectedCallOutcomes(value);
    updateQuery({ outcomes: value });
    captureAnalytics('voice_outbound_call_outcome_filter_changed', {
      outcomes: value,
      count: value.length,
    });
  };

  return (
    <Select
      className="voice-outbound-subheader-select compact-multi-select"
      mode="multiple"
      placeholder="Call Outcome"
      options={Object.values(CALL_OUTCOME_TAGS).filter((value) => (
        isOutcomeVisible(value.value, inboundDeliveryOutcomesEnabled, inboundDeliveryOutcomes)
      )).map((value) => ({
        label: value.label,
        value: value.value,
      }))}
      allowClear={true}
      value={selectedCallOutcomes}
      onChange={(value) => handleCallOutcomeChange(value)}
      style={{ minWidth: '140px' }}
      dropdownMatchSelectWidth={false}
      placement="bottomRight"
      maxTagCount={getCompactMultiSelectMaxTagCount(selectedCallOutcomes)}
      maxTagPlaceholder={getCompactMultiSelectPlaceholder('call outcomes')}
    />
  );
};

CallOutcomeFilter.defaultProps = {
  updateQuery: () => {},
  selectedCallOutcomes: [],
  setSelectedCallOutcomes: () => {},
  inboundDeliveryOutcomesEnabled: false,
  inboundDeliveryOutcomes: [],
};

CallOutcomeFilter.propTypes = {
  updateQuery: PropTypes.func,
  selectedCallOutcomes: PropTypes.array,
  setSelectedCallOutcomes: PropTypes.func,
  inboundDeliveryOutcomesEnabled: PropTypes.bool,
  inboundDeliveryOutcomes: PropTypes.arrayOf(PropTypes.string),
};

export default withRouter(CallOutcomeFilter);
